import { render, staticRenderFns } from "./organizationTreatments.vue?vue&type=template&id=5a36cf04&scoped=true&"
import script from "./organizationTreatments.vue?vue&type=script&lang=js&"
export * from "./organizationTreatments.vue?vue&type=script&lang=js&"
import style0 from "./organizationTreatments.vue?vue&type=style&index=0&id=5a36cf04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36cf04",
  null
  
)

export default component.exports